<template>
    <div>
        <div class="user_section">
            <div class="row">
                <div class="col-12">
                    <div class="img-wrapper">
                        <a :href="profileUrl">
                            <img :src="imagePath" alt="user not found" class="rounded-circle profile-image">
                        </a>
                    </div>
                    <p class="mt-2 mb-1 user_name_max text-center">{{ user.full_name }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'user_profile',

    computed: {
        ...mapGetters({
            user: 'authUser',
        }),
        imagePath() {
            if (!this.user || !this.user.image_id) {
                return this.profileImagePath;
            }

            return route("resource.files.show", {file: this.user.image_id});
        },
        profileUrl() {
            return '/admin/relations/my-profile'
        }
    },

    data() {
        return {
            profileImagePath: '/images/login_user-01.png',
        }
    },

    methods: {
        async logout() {
            await this.$store.dispatch('logout')

            // Redirect to login.
            this.$router.push({name: 'login'})
        },
    }
}
</script>
<style scoped lang="scss">
@import "../../css/customvariables";

.user_section {
    height: 188px;
    padding: 15px 20px;

    .img-wrapper{
        width: 100px;
        height: 100px;
        border-radius:50%;
        padding:7px;
        margin:auto;
    }
    img {
        border: 2px solid #ccc;
        overflow: hidden;
    }

    p {
        font-size: 15px;
    }
}
.user_name_max {
    text-transform:uppercase;
    font-weight:700;
    max-width: 210px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
    margin: 0 0 -4px;
    padding-top: 2px;
    padding-bottom: 5px;
}

.profile-image {
    max-width: 84px;
    height: 84px;
    width: 84px;
}

</style>
